import {Text, TextVariantUnionType} from "@pg-design/text-module";
import {PAGINATION_TEST_IDS} from "@pg-mono/test-ids";

import {PaginationSize} from "../types/PaginationSize";

import * as styles from "./PageSeparator.module.css";

interface IProps {
    size: PaginationSize;
    textVariant: TextVariantUnionType;
}

export const PageSeparator = (props: IProps) => {
    return (
        <Text as="span" className={styles.pageSeparator} dataTestId={PAGINATION_TEST_IDS.PAGE_SEPARATOR} variant={props.textVariant}>
            ...
        </Text>
    );
};
import {Text, TextVariantUnionType} from "@pg-design/text-module";
import {PAGINATION_TEST_IDS} from "@pg-mono/test-ids";

import {PaginationSize} from "../types/PaginationSize";

import * as styles from "./PageSeparator.module.css";

interface IProps {
    size: PaginationSize;
    textVariant: TextVariantUnionType;
}

export const PageSeparator = (props: IProps) => {
    return (
        <Text as="span" className={styles.pageSeparator} dataTestId={PAGINATION_TEST_IDS.PAGE_SEPARATOR} variant={props.textVariant}>
            ...
        </Text>
    );
};
